export var TipConfiguration;
(function (TipConfiguration) {
    let ComponentNames;
    (function (ComponentNames) {
        ComponentNames["rootScreen"] = "root_screen";
        ComponentNames["numberInput"] = "number_input";
        ComponentNames["avatar"] = "avatar";
        ComponentNames["option"] = "option";
        ComponentNames["options"] = "options";
        ComponentNames["header"] = "header";
        ComponentNames["tipScreen"] = "tip_screen";
        ComponentNames["normalTipScreen"] = "normal_tip_screen";
        ComponentNames["compactTipScreen"] = "compact_tip_screen";
        ComponentNames["statusScreen"] = "status_screen";
        ComponentNames["screen"] = "screen";
        ComponentNames["tipModal"] = "tip_modal";
    })(ComponentNames = TipConfiguration.ComponentNames || (TipConfiguration.ComponentNames = {}));
})(TipConfiguration || (TipConfiguration = {}));
